import React from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
};

function ModalSaveCheck({ data, closeModal }) {
  const { history, item } = data;

  function setStatus(val) {
    history.push({
      pathname: '/administrasi/absensi/edit/' + item.id,
      state: {
        modalStatus: val,
      },
    });
    closeModal();
  }

  return (
    <Modal variant='info' closeModal={closeModal}>
      <p className='my-3 mx-1'>
        Apakah Anda ingin menyimpan absensi tanggal{' '}
        <span className='has-text-danger has-text-weight-semibold is-capitalized'>
          {`${item?.year}-${item?.month}-${item?.date}`}
        </span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='csave' onClick={() => setStatus('save')} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalSaveCheck);
